import { IBase } from 'src/app/core';
import { IDoctor } from '../doctor';

export interface IDevice extends IBase {
  serial: string[];
  createdDate: Date | string;
  doctor: IDoctor;
}
